import { pick, get } from 'lodash';

export const sanitiseGroupData = (params) => {
  const allowedParams = pick(params, [
    'id', 'name', 'summary', 'industry', 'website', 'avatarUrl', 'bannerUrl', 'causeIds',
    'parentId', 'folderId', 'type', 'draft', 'location', 'applicationSettings', 'memberTypes',
    'blockApplications', 'insurances', 'insuranceAuspicedOrganisation', 'insuranceStatus',
  ]);

  const input = { ...allowedParams };

  if (params && params.insuranceStatus) {
    /**
     * Update insurance details based on the insuranceStatus
     */
    if (params.insuranceStatus === 'uninsured' || params.insuranceStatus === 'auspiced') {
      // Remove any previously entered insurance details
      input.insurances = null;
      // Remove Auspiced details as well for 'uninsured'
      if (params.insuranceStatus === 'uninsured') {
        input.insuranceAuspicedOrganisation = null;
      }
    }
    else {
      // Remove Auspiced details when is 'insured'
      input.insuranceAuspicedOrganisation = null;
      input.insurances = input.insurances[get(input.location, 'country.short')];
    }
  }

  if (input.name === null) {
    /**
     * 'null' value of the [name] field will cause an error in the
     * <HierarchyView> component which displays at the background of the wizard
     * when create a new group, where [name] is a required property
    */
    input.name = '';
  }

  return input;
};
